import { get } from 'lodash';
import React, { Component } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { showAuthenticationPopup, load } from '../../../actions/common';
import { firebaseSigninRedirect, firebaseSigninUsernameAndPassword } from '../../../actions/auth';
import { renderTextField } from '../../../assets/formComponent';
import { validateEmail, validatePassword } from '../../../assets/util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { authControlState } from '../authControlState';

class LoginForm extends Component {

    constructor(props) {
        super(props);
        this.firebaseFbLogin = this.firebaseFbLogin.bind(this);
        this.firebaseGgLogin = this.firebaseGgLogin.bind(this);
        this.firebaseAppleLogin = this.firebaseAppleLogin.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.authenticated === false && nextProps.authenticated === true) {
            this.props.showAuthenticationPopup(false);
        }
        if (this.props.auth_error !== nextProps.auth_error) {
            window.scrollTo(0, 0);
            if (this.props.suspicious) {
                this.props.change('popupLoginForm', 'secret', '');
            }
        }
    }

    onSubmit(values) {
        var error_obj = { _error: 'Login failed!' };
        var error = false;

        if (!values.email) {
            error_obj.email = "Email is required";
            error = true;
        } else if (!validateEmail(values.email)) {
            error_obj.email = "Email is invalid";
            error = true;
        }

        if (!values.password) {
            error_obj.password = "Password is required";
            error = true;
        } else if (!validatePassword(values.password)) {
            error_obj.password = "Password needs to be more than 8 characters.";
            error = true;
        }

        if (error) {
            throw new SubmissionError(error_obj);
        } else {
            return this.props.firebaseSigninUsernameAndPassword(values.email, values.password);
        }
    }

    firebaseFbLogin() {
        this.props.firebaseSigninRedirect("facebook");
    }

    firebaseGgLogin() {
        this.props.firebaseSigninRedirect("google");
    }

    firebaseAppleLogin() {
        this.props.firebaseSigninRedirect("apple");
    }

    render() {
        const { handleSubmit, translate, q, authPending } = this.props;
        const { auth_error } = this.props;
        const email = authControlState(authPending, 'email');
        const facebook = authControlState(authPending, 'facebook');
        const google = authControlState(authPending, 'google');
        const apple = authControlState(authPending, 'apple');

        return (
            <div className="auth-form-container">
                <form className="auth-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    {/* Error Alert */}
                    {(auth_error || Boolean(get(q, "error", null))) && (
                        <div className="error-alert">
                            <div className="error-message">
                                <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="error-icon" />
                                {translate(`ERROR.AUTH.${get(auth_error, 'code', null)}`, auth_error.message, { showMissingTranslationMsg: auth_error.message }) || translate(`ERROR.${get(q, "error", "").toUpperCase()}`)}
                            </div>
                        </div>
                    )}

                    {/* Form Fields */}
                    <div className="form-fields">
                        <Field
                            component={renderTextField}
                            label="Email"
                            name="email"
                            type="text"
                            className="form-field"
                        />
                        <Field
                            component={renderTextField}
                            label="Password"
                            name="password"
                            type="password"
                            className="form-field"
                        />
                    </div>

                    {/* Forgot Password Link */}
                    <div className="forgot-password-container">
                        <button
                            type="button"
                            onClick={this.props.onForgotClick}
                            className="forgot-password-link"
                        >
                            ลืมรหัสผ่าน
                        </button>
                    </div>

                    {/* The reCAPTCHA v2 widget that stood here was removed in item 01. It
                        was dead three independent ways: REACT_APP_GG_SITE_KEY was never
                        set, `suspicious` has no producer on the Firebase login path, and
                        `onSubmit` never read `values.captchaResponse`. Live bot protection
                        is now (a) reCAPTCHA Enterprise inside Firebase, ahead of token
                        minting, and (b) the signup challenge on the two signup forms. */}

                    {/* Submit Button */}
                    <button className="btn btn-primary submit-btn" type="submit" disabled={email.disabled}>
                        <FontAwesomeIcon icon={['fas', email.pending ? 'spinner' : 'sign-in-alt']} className="btn-icon" spin={email.pending} />
                        {email.pending ? translate('AUTH_SIGNING_IN') : 'เข้าสู่ระบบ'}
                    </button>

                    {/* Divider */}
                    <div className="divider">
                        <span className="divider-text">หรือ</span>
                    </div>

                    {/* Social Login Buttons */}
                    <div className="social-buttons">
                        <button
                            className="social-btn facebook-btn"
                            type="button"
                            onClick={this.firebaseFbLogin}
                            disabled={facebook.disabled}
                        >
                            <FontAwesomeIcon icon={facebook.pending ? ['fas', 'spinner'] : ['fab', 'facebook-f']} className="social-icon" spin={facebook.pending} />
                            {facebook.pending ? translate('AUTH_SIGNING_IN') : 'เข้าสู่ระบบด้วย Facebook'}
                        </button>

                        <button
                            className="social-btn google-btn"
                            type="button"
                            onClick={this.firebaseGgLogin}
                            disabled={google.disabled}
                        >
                            <FontAwesomeIcon icon={google.pending ? ['fas', 'spinner'] : ['fab', 'google']} className="social-icon" spin={google.pending} />
                            {google.pending ? translate('AUTH_SIGNING_IN') : 'เข้าสู่ระบบด้วย Google'}
                        </button>

                        <button
                            className="social-btn apple-btn"
                            type="button"
                            onClick={this.firebaseAppleLogin}
                            disabled={apple.disabled}
                        >
                            <FontAwesomeIcon icon={apple.pending ? ['fas', 'spinner'] : ['fab', 'apple']} className="social-icon" spin={apple.pending} />
                            {apple.pending ? translate('AUTH_SIGNING_IN') : 'เข้าสู่ระบบด้วย Apple'}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        auth_error: state.auth.error,
        suspicious: state.common.suspicious,
        authPending: state.common.authPending,
        translate: getTranslate(state.locale),
    }
}

export default reduxForm({
    form: 'popupLoginForm'
})(connect(mapStateToProps, { showAuthenticationPopup, load, firebaseSigninRedirect, firebaseSigninUsernameAndPassword })(LoginForm));